import { gql, useQuery } from "@apollo/client";
import {
  Avatar,
  ChevronDownIcon,
  ChevronUpIcon,
  Label,
  Spinner,
  toaster,
} from "evergreen-ui";
import React, { useState } from "react";
import styled from "styled-components";

const GET_USER_DOWNLINES = gql`
  query getDownlineByUserName($username: String) {
    user: users(where: { username: { _eq: $username } }) {
      id
      name
      username
      avatar
      user_rank {
        id
        name
        chinese_name
      }
      downline_count
    }
    downlines: users(
      where: { users_upline: { username: { _eq: $username } } }
    ) {
      id
      name
      username
      avatar
      user_rank {
        id
        name
        chinese_name
      }
      downline_count
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 0.4rem;
  padding-left: 0.8rem;
`;

const NameContainer = styled.div`
  display: flex;
  cursor: pointer;
  :hover {
    background-color: ${(props) => props.theme.lightGreyColor};
  }
  border-radius: 1rem;
  align-items: center;
  flex-direction: row;
`;

const Name = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 0.4rem;
`;
interface IProps {
  username: string;
  expand?: boolean;
  onClick?: any;
}
const UserNetwork: React.SFC<IProps> = ({
  username,
  expand = false,
  onClick = (username) => {
    toaster.success(username);
  },
}) => {
  const arrowSize = 18;
  const [show, setShow] = useState(expand);
  const { data, loading, error } = useQuery(GET_USER_DOWNLINES, {
    variables: {
      username,
    },
  });

  const toggleShow = () => {
    setShow(!show);
  };
  return (
    <Container>
      {loading && <Spinner />}
      {!loading && error && <Label>Error: {error.message}</Label>}
      {!loading && data && data.user && data.user.length > 0 && (
        <NameContainer>
          {show ? (
            <ChevronUpIcon size={arrowSize} onClick={toggleShow} />
          ) : (
            <ChevronDownIcon size={arrowSize} onClick={toggleShow} />
          )}{" "}
          <Name
            onClick={() => {
              onClick(username);
            }}
          >
            <Avatar
              size={20}
              marginRight={".4rem"}
              src={data.user[0].avatar}
              name={data.user[0].name}
            />
            {data.user[0].name + " (" + data.user[0].username + ")"}
          </Name>
        </NameContainer>
      )}
      {show &&
        !loading &&
        data &&
        data.downlines &&
        (data.downlines.length > 0
          ? data.downlines.map((downline, index) => (
              <UserNetwork
                onClick={onClick}
                key={index}
                username={downline.username}
              />
            ))
          : "No downline!")}
    </Container>
  );
};

export default UserNetwork;
